module.exports = __webpack_public_path__ + "e38ed0481a52fbd90f2562a25aabe181.svg";